export default {
    intro: 'ลองเรียงประโยคที่สลับกันให้ถูกลำดับดูสิ!',
    indicator: ({ values }: { values: { isAllDone: boolean } }) => {
        const { isAllDone } = values;
        if (isAllDone) {
            return 'ลองอ่านข้อความที่เรียงเสร็จอีกครั้งนะ';
        }
        return 'ลองเรียงลำดับประโยคให้ถูกต้องดูสิ!';
    },
    retry: ({ values }: { values: { count: number } }) =>
        `น่าเสียดาย! ยังมีอีก ${values.count} ประโยคที่ยังไม่เข้าที่ มีโอกาสอีกครั้ง ลองใหม่กันเถอะ!`,
    exhausted: 'จะบอกคำตอบให้นะ! ครั้งหน้าต้องทำได้แน่นอน',
    viewCompleted: 'ดูข้อความที่เรียงเสร็จ',
    table: {
        question: 'โจทย์',
        answerRate: 'อัตราการตอบถูก',
        emptyMessage: 'ไม่มีเนื้อหา',
    },
    roundNumber: 'ข้อที่ {number}',
};
